import React from 'react'

import EditPackage from '../components/organisms/EditPackage'

function EditarPacotes() {
  return <EditPackage />
}

export default EditarPacotes
